export enum ConversationSortEnum {
    Recent = "recent",
    Unread = "unread"
}
